import { createContext, useContext, useMemo, ReactNode } from 'react';

import { InlineEditsManager } from '../services/InlineEditsManager';
import { useMplServiceClient } from './MplServiceClientContext';

export const InlineEditsManagerContext = createContext<InlineEditsManager | undefined>(undefined);

export function InlineEditsManagerProvider({ children }: { children: ReactNode }) {
  const mpl = useMplServiceClient();
  const service = useMemo(() => new InlineEditsManager(mpl), [mpl]);
  return (
    <InlineEditsManagerContext.Provider value={service}>
      {children}
    </InlineEditsManagerContext.Provider>
  );
}

export function useInlineEditsManager(): InlineEditsManager {
  const context = useContext(InlineEditsManagerContext);
  if (!context) {
    throw new Error('useInlineEditsManager must be used within InlineEditsManagerProvider');
  }
  return context;
}
